import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App.vue'
import store from './store'
import router from './router'
import 'vant/lib/index.css'
import './utils/back'
import { Lazyload } from 'vant'
import VueI18n from 'vue-i18n'
import myheader from '@/views/components/header'
import myfooter from '@/views/components/footer'

import Cookies from 'js-cookie'
/*const whiteList = ['/login', '/'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {

  const token = Cookies.get('token')
  if (token) {
    // if (to.path === '/login') {
    //   next({ path: '/' })
    // } else {
    if (store.getters.name) {
      next()
    } else {
      try {
        await store.dispatch('user/getInfo')
        next({ ...to, replace: true })
      } catch (error) {
        Cookies.remove('token')
        next(`/login?redirect=${to.path}`)
      }
    }
    // }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
    }
  }
})*/
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: store.state.app.lang,
  messages: {
    'zh': require('../static/lang/zh'),
    'en': require('../static/lang/en')
  }
})
Vue.use(Lazyload)
Vue.use(VueRouter)
Vue.component('myheader', myheader)
Vue.component('myfooter', myfooter)
FastClick.attach(document.body)

Vue.config.productionTip = false
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
